import { ethers } from 'ethers';
import { formatEther } from 'ethers/lib/utils';
import { useContext, useEffect, useState } from 'react';

import WETHAbi from '@/abis/WETHAbi';
import {
  getMetamaskProvider,
  getWeb3Provider,
  isMetamaskConnected,
} from '@/apis/blockchain/blockchainCommon';
import CurrentUserContext from '@/contexts/CurrentUserContext';

import { addresses } from './../constants/addresses';

const useCurrentWethBalance = (): {
  currentWethBalance: string;
  getCurrentWethBalance(): Promise<string>;
  metamaskConnected: boolean;
} => {
  const currentUserContext = useContext(CurrentUserContext);
  const [currentWethBalance, setCurrentWethBalance] = useState('0');
  const [metamaskConnected, setMetamaskConnected] = useState(false);

  const getCurrentWethBalance = async () => {
    if (!currentUserContext.currentUser) return;

    const metamaskProvider = await getMetamaskProvider();
    const web3Provider = getWeb3Provider(metamaskProvider);

    const wethContract = new ethers.Contract(
      addresses.WrappedETH ?? '',
      WETHAbi,
      web3Provider
    );

    const balance = await wethContract.balanceOf(
      currentUserContext.currentUser.userID
    );

    return formatEther(balance);
  };

  useEffect(() => {
    const f = async () => {
      const metamaskProvider = await getMetamaskProvider();
      setMetamaskConnected(await isMetamaskConnected(metamaskProvider));

      const balance = await getCurrentWethBalance();
      setCurrentWethBalance(balance);
    };

    f();
  }, [currentUserContext.currentUser]);

  return {
    currentWethBalance,
    getCurrentWethBalance,
    metamaskConnected,
  };
};

export default useCurrentWethBalance;
